module.exports = __webpack_public_path__ + "static/media/promo.8b274e9f.png";